export const JUSTIFICATION_MAX_LENGTH = 2000;
